import { ConnectedRouter } from 'connected-react-router';
import moment from 'moment';
import React, { FC, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { QueryClientProvider, QueryClient } from 'react-query';
import { useSelector, Provider } from 'react-redux';
import { CurrentUserProvider, AccountProvider } from 'contexts/providers';
import { store, history } from 'data';
import { selectActiveDocumentInfo } from 'data/documents';
import { localeData } from 'translations/en-moment';
import translations from 'translations/en.json';
import {
  EditorData,
  EditorDataContext,
} from '../editor-data/editor-data-store';
import { DocumentTasksSection } from '../tasks-section';

const queryClient = new QueryClient();

interface TaskSectionProps {
  resourceSectionId: number;
}

const TaskSection: FC<TaskSectionProps> = ({ resourceSectionId }) => {
  const locale = 'en';

  useLayoutEffect(() => {
    moment.updateLocale(locale, localeData);
  }, [locale]);

  const { documentId, projectId } = useSelector(selectActiveDocumentInfo);

  return documentId !== null && projectId !== null ? (
    <AccountProvider>
      <CurrentUserProvider>
        <DocumentTasksSection
          resourceSectionId={resourceSectionId}
          documentId={documentId}
          projectId={projectId}
        />
      </CurrentUserProvider>
    </AccountProvider>
  ) : null;
};

export const taskSectionRenderer = (
  resourceSectionId: string,
  container: HTMLElement,
  editorData: EditorData,
): void => {
  const locale = 'en';

  ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <IntlProvider locale={locale} messages={translations}>
          <QueryClientProvider client={queryClient}>
            <EditorDataContext.Provider value={editorData}>
              <TaskSection
                resourceSectionId={parseInt(resourceSectionId, 10)}
              />
            </EditorDataContext.Provider>
          </QueryClientProvider>
        </IntlProvider>
      </ConnectedRouter>
    </Provider>,
    container,
  );
};
